module.exports = __webpack_public_path__ + "img/TwoAxleTractorSingleAxleSemitrailer.ae140fa7.svg";